/**
 * 
 * @param {array} data 需要过滤的数组
 * @returns 
 */
import store from '../../store';
export function instructFilter(data) {
    var devTypeList = JSON.parse(store.state.devTypeList)
    let arr = devTypeList.filter(item => {
        return item.name === data;
    })
    return arr.length > 0 ? arr[0].id : ''
}
export default {
    instructFilter
};